import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface EffectsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<EffectsServiceData>(db, 'effectsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
